import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { PersistOptions } from "zustand/middleware";
import type { Feature } from "~/types/api";

export interface FeaturesState {
  features: Feature[] | [];

  setFeatures: (features: Feature[]) => void;

  // Computed values
  hasFeatureAccess: (name: string) => boolean;

  reset: () => void;
}

const useFeaturesState = create<FeaturesState>()(
  persist(
    (set, get) => ({
      features: [],

      setFeatures: (features: Feature[]) => set(() => ({ features: features })),

      hasFeatureAccess: (name: string) =>
        get().features.some((f) => f.name === name),

      reset: () =>
        set(() => ({
          features: [],
        })),
    }),
    {
      name: "feature-state",
    } as PersistOptions<FeaturesState>,
  ),
);

export default useFeaturesState;

export const FEATURES = {
  MAP_DASHBOARD: "FEATURE_MAP_DASHBOARD",
  CAM_ONLINE: "CAM_ONLINE",
  MULTI_COMPANY: "FEATURE_MULTI_COMPANY",
  PER_COMPANY_BRANDING: "FEATURE_PER_COMPANY_BRANDING",
  OPC: "FEATURE_OPC_UA",
};
